__webpack_require__.p = "/fr_MA/";